// Guards against DUPLICATE payments when the user back-navigates onto a
// plan/checkout screen AFTER a successful payment and taps pay again.
//
// Flow: PaymentSuccess marks the agent as just-paid; every pay/checkout handler
// checks this first and refuses to start a second Stripe session; a deliberate
// "Upgrade Plan" click clears it so a real later upgrade still works.
//
// Keyed per-agent + timestamped, and stored in sessionStorage so it survives
// in-app navigation (and the Stripe round-trip) but not a brand-new tab.

const KEY_PREFIX = "agentJustPaid_";
// How long a payment "blocks" re-payment. Long enough to cover back-navigation
// right after checkout, short enough that a much later revisit isn't blocked.
const WINDOW_MS = 30 * 60 * 1000; // 30 minutes

export const markAgentPaid = (agentId) => {
  if (!agentId) return;
  try {
    sessionStorage.setItem(`${KEY_PREFIX}${agentId}`, String(Date.now()));
  } catch (_e) {
    /* ignore */
  }
};

export const isAgentRecentlyPaid = (agentId) => {
  if (!agentId) return false;
  try {
    const ts = parseInt(sessionStorage.getItem(`${KEY_PREFIX}${agentId}`), 10);
    if (!ts) return false;
    if (Date.now() - ts > WINDOW_MS) {
      sessionStorage.removeItem(`${KEY_PREFIX}${agentId}`);
      return false;
    }
    return true;
  } catch (_e) {
    return false;
  }
};

// Called when the user deliberately starts a NEW upgrade so the guard doesn't
// block a legitimate later purchase.
export const clearAgentPaid = (agentId) => {
  if (!agentId) return;
  try {
    sessionStorage.removeItem(`${KEY_PREFIX}${agentId}`);
  } catch (_e) {
    /* ignore */
  }
};
